import * as React from 'react';
import * as c from 'models/constants';
import { RouteComponentProps } from 'react-router';
import { IShopProfile } from 'models/shop/shopprofile';
import { ManageShopWrapper } from 'containers';
import { getConnectedShopLocations } from 'containers/Shop/Common/ShopLocations';
import { connect, Dispatch } from 'react-redux';
import { getShop, putShop } from 'modules/shop/manageshop';
import { IStore } from 'redux/IStore';
import { closeModal, showModal } from 'redux/modules/modal';
import { ICreateShopObject } from 'models/shop/createshop';

interface IRouterParams {
	id?: string;
}

interface IProps
	extends RouteComponentProps<IRouterParams, {}>,
		ReturnType<typeof stateToProps>,
		ReturnType<typeof dispatchToProps> {}

const ShopLocations = getConnectedShopLocations(c.FORM_NAME_MANAGE_SHOP);

const ManageShopLocationsForm: React.FC<IProps> = (props: IProps) => {
	const { id } = props.params;
	const [readOnly, toggleReadOnly] = React.useState(true);

	React.useEffect(() => {
		props.getShop(id);
	}, [id]);

	const saveShop = (fullData: ICreateShopObject<IShopProfile>) => {
		toggleReadOnly(true);
		props.putShop(fullData.shop);
	};

	const content = props.offices ? (
		<ShopLocations
			{...props}
			readOnly={readOnly}
			toggleReadOnly={() => toggleReadOnly(!readOnly)}
			redux="manageShop"
			onSubmit={saveShop}
		/>
	) : null;

	return (
		<ManageShopWrapper route={props.route} id={id} shop={props.shop}>
			{content}
		</ManageShopWrapper>
	);
};

const stateToProps = (state: IStore) => ({
	shop: state.manageShop.shop,
	offices: state.manageShop?.shop?.offices,
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	getShop: (id: string) => dispatch(getShop(id, false, false)),
	putShop: (form: IShopProfile) => dispatch(putShop(form, 'offices')),
	closeModal: () => dispatch(closeModal()),
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
});

const ManageShopLocations = connect(stateToProps, dispatchToProps)(ManageShopLocationsForm);

export { ManageShopLocations };
